import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SessionDetails } from "AttendanceForm/Utils/GraphQl/AttendanceFormData";
import { RootState } from "store";

export interface AttendanceFormSessionDetailsSliceState {
  loading: boolean;
  fetched: boolean;
  session: SessionDetails;
}

const initialState: AttendanceFormSessionDetailsSliceState = {
  loading: false,
  fetched: false,
  session: null,
};

const attendanceFormSessionDetailsSlice = createSlice({
  name: "AttendanceFormSessionDetails",
  initialState,
  reducers: {
    fetchAttendanceFormSessionDetailsSuccess(state, action: PayloadAction<SessionDetails>) {
      state.loading = false;
      state.session = action.payload;
      state.fetched = true;
    },
  },
});

const attendanceFormSessionDetailsActions = attendanceFormSessionDetailsSlice.actions;
const selectAttendanceFormSessionDetails = (
  state: RootState
): AttendanceFormSessionDetailsSliceState => state.attendanceForm.attendanceFormSessionDetails;

export {
  attendanceFormSessionDetailsSlice,
  attendanceFormSessionDetailsActions as AttendanceFormSessionDetailsActions,
  selectAttendanceFormSessionDetails,
};
